import { AGENT_BY_ID } from '../config/competition'
import { ago, compactMoney, price as fmtPrice, signedCompactMoney, signedPct } from '../core/format'
import type { Position } from '../core/types'
import { AssetIcon } from './primitives/Media'
import { Panel } from './primitives/Panel'
import { Standby } from './primitives/Standby'

export function PositionsPanel({
  positions,
  now,
  standby,
}: {
  positions: Position[]
  now: number
  standby: boolean
}) {
  if (standby) {
    return (
      <Panel title="OPEN POSITIONS" flush>
        <Standby note="Every open position, its size and its mark." />
      </Panel>
    )
  }

  const sorted = [...positions].sort((a, b) => b.pnl - a.pnl)
  const gross = positions.reduce((s, p) => s + p.notional, 0)

  return (
    <Panel
      title="OPEN POSITIONS"
      note={
        <span className="u-num">
          {positions.length} / {compactMoney(gross)}
        </span>
      }
      scroll
      flush
      className="positions"
    >
      {sorted.length === 0 ? (
        <p className="empty">All four agents are flat.</p>
      ) : (
        <ul className="poslist">
          {sorted.map((p) => {
            const a = AGENT_BY_ID[p.agentId]
            const up = p.pnl >= 0
            return (
              <li key={p.id} className="pos" style={{ ['--accent' as string]: a?.color }}>
                <div className="pos__l1">
                  <AssetIcon symbol={p.symbol} chain={p.chain} size={20} />
                  <span className="pos__sym">{p.symbol}</span>
                  <span className={`pos__side pos__side--${p.side}`}>{p.side.toUpperCase()}</span>
                  <span className="pos__agent">{a?.name}</span>
                  <span className={`pos__pnl u-num ${up ? 'u-up' : 'u-down'}`}>
                    {signedCompactMoney(p.pnl)}
                    <em>{signedPct(p.pnlPct, 1)}</em>
                  </span>
                </div>
                <div className="pos__l2">
                  <span className="u-label">{p.venue}</span>
                  <span className="pos__kv">
                    <i>SIZE</i>
                    <b className="u-num">{compactMoney(p.notional)}</b>
                  </span>
                  <span className="pos__kv">
                    <i>ENTRY</i>
                    <b className="u-num">{fmtPrice(p.entry)}</b>
                  </span>
                  <span className="pos__age u-num">{ago(p.openedAt, now)}</span>
                </div>
              </li>
            )
          })}
        </ul>
      )}
    </Panel>
  )
}
